import { Tab, Tabs, Typography, Grid } from '@material-ui/core';
import { GrupoAcesso, Perfil } from 'common/genericTypes';
import { LgSpace } from 'm2m.components';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import { HorizontalAppBar } from 'components/horizontalAppBar';
import Usuarios from './usuarios';
import Notificacoes from './notificacoes';

const GestaoAcessos: React.FC = () => {
  const isUsuarioLeitura = useSelector((state: RootState) => state.auth.usuario.participante.perfil === Perfil.Leitura);
  const [tabValue, setTabValue] = useState(0);

  return (
    <div style={{ marginRight: 40 }}>
      <Grid container justifyContent="space-between" direction="row" alignItems="center">
        <Typography variant="h1">{'Gestão de Acessos'}</Typography>
      </Grid>
      <LgSpace />

      <HorizontalAppBar>
        <Tabs
          value={tabValue}
          indicatorColor="primary"
          textColor="primary"
          onChange={(_event, newTab) => setTabValue(newTab)}
        >
          <Tab label="Usuários" value={0} />
          {!isUsuarioLeitura && <Tab label="Notificações" value={1} />}
        </Tabs>
      </HorizontalAppBar>

      {tabValue === 0 && <Usuarios />}
      {tabValue === 1 && !isUsuarioLeitura && <Notificacoes />}

      <LgSpace />
    </div>
  );
};

export default GestaoAcessos;